var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"https://familyoptic.pl/regulaminy-i-informacje-prawne/"}},[_vm._v("Regulaminy i informacje prawne")])]),_c('li',[_c('a',{attrs:{"href":"https://familyoptic.pl/polityka-prywatnosci.html"}},[_vm._v("Polityka prywatności")])])])
}]

export { render, staticRenderFns }